import { createAsyncThunk } from '@reduxjs/toolkit';
import MarketplaceSuppliersResource from 'api/service/MarketplaceSuppliersResource';

export const listAllAutocompleteSuppliers = createAsyncThunk(
  'suppliers/listAllAutocompleteSuppliers',
  async (initialData, { rejectWithValue }) => {
    const marketplaceSuppliersResource = new MarketplaceSuppliersResource();
    const { query = '' } = initialData || {};
    const params = { size: 10, offset: 0, search: query || '' };

    const { status, data } = await marketplaceSuppliersResource.list(params);

    if (status === 200) {
      return { data: data || [], offset: 10 };
    }
    return rejectWithValue('Suppliers not found');
  }
);

export const listAllAutocompleteSuppliersNext = createAsyncThunk(
  'suppliers/listAllAutocompleteSuppliersNext',
  async (initialData, { rejectWithValue }) => {
    const marketplaceSuppliersResource = new MarketplaceSuppliersResource();
    const { offset = 0, query = '' } = initialData || {};
    const params = { size: 10, offset: offset || 0, ...(query ? { search: query } : {}) };

    const { status, data } = await marketplaceSuppliersResource.list(params);

    if (status === 200) {
      return { data: data || [], offset: offset + 10 };
    }
    return rejectWithValue('Suppliers not found');
  }
);
